import { CorpSurveyModal, Icon, IconName } from "halifax";
import React, { useEffect, useState } from "react";
import { MODAL_ALERT, MODAL_ALERT_CHOICE, ModalNames } from "redmond";

import { trackEvent } from "../../../api/v1/trackEvent";
import { updateUserSeenModal } from "../../../api/v1/user/updateUserSeenModal";

export interface SeanEllisSurveyModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const surveyOptions = [
  {
    id: 1,
    label: "Very disappointed",
    tracking_property: "very_disappointed",
  },
  {
    id: 2,
    label: "Somewhat disappointed",
    tracking_property: "somewhat_disappointed",
  },
  {
    id: 3,
    label: "Not disappointed (it isn't that useful)",
    tracking_property: "not_disappointed",
  },
];

export const SeanEllisSurveyModal = ({
  isOpen,
  onClose,
}: SeanEllisSurveyModalProps) => {
  const [selectedSurveyOption, setSelectedSurveyOption] = useState(-1);

  useEffect(() => {
    if (isOpen) {
      trackEvent({
        eventName: MODAL_ALERT,
        properties: {
          type: "sean_ellis_question",
        },
      });
    }
  }, [isOpen]);

  const handleSubmitSurvey = () => {
    trackEvent({
      eventName: MODAL_ALERT_CHOICE,
      properties: {
        type: "sean_ellis_question",
        choice: surveyOptions[selectedSurveyOption - 1].tracking_property,
      },
    });
    updateUserSeenModal({
      modalName: "sean_ellis",
    }).catch((e) => {
      console.error("Issue persisting seen sean ellis", e);
      onClose();
    });
  };

  const handleSubmitFeedback = (feedback: string, canContact: boolean) => {
    trackEvent({
      eventName: "corp_sean_ellis_feedback",
      properties: {
        feedback,
        you_can_contact_me: canContact,
      },
    });
    onClose();
  };

  const handleChangeSurveyOption = (optionId: number) => {
    setSelectedSurveyOption(optionId);
  };

  const handleCloseSurveyModal = () => {
    onClose();
    updateUserSeenModal({
      modalName: ModalNames.SEAN_ELLIS_MODAL,
    }).catch((e: Error) => {
      console.error("Issue persisting seen sean ellis", e);
    });
  };

  return (
    <CorpSurveyModal
      isOpen={isOpen}
      onClose={handleCloseSurveyModal}
      title="How would you feel if you could no longer use Capital One Business Travel?"
      subtitle="Don't worry, we're not going anywhere! Answering helps us improve
          our product for valued customers like you. (Optional)"
      feedbackTitle="Thanks for your feedback!"
      feedbackSubtitle="We're constantly working to meet your expectations.
Tell us a bit more to help us improve our product."
      image={<Icon name={IconName.SurveyQuestionMark} />}
      options={surveyOptions}
      onSubmitOptions={handleSubmitSurvey}
      onSubmitFeedback={handleSubmitFeedback}
      onOptionChange={handleChangeSurveyOption}
      selectedOptionId={selectedSurveyOption}
      trackEvent={trackEvent}
    />
  );
};

export default SeanEllisSurveyModal;
